import type { InterfaceTableMeta } from '../../app'

// The source table, written in English by the project (ADR-111).
export const meta: InterfaceTableMeta = { review: 'native-reviewed' }
